export type AuxiliaryCollectionMode = 'favs' | 'drafts' | 'trash'

export type DeskViewMode = 'msg' | 'answers' | 'submsges' | 'attachments' | AuxiliaryCollectionMode

const legacySwitcherByMode: Readonly<Record<DeskViewMode, number>> = {
  msg: 0,
  answers: 9,
  submsges: 10,
  attachments: 8,
  favs: 6,
  drafts: 13,
  trash: 5,
}

export function legacySwitcherForDeskMode(mode: DeskViewMode): number {
  return legacySwitcherByMode[mode]
}

export function deskModeFromLegacySwitcher(switcherId: number): DeskViewMode | undefined {
  return (Object.keys(legacySwitcherByMode) as DeskViewMode[])
    .find(mode => legacySwitcherByMode[mode] === switcherId)
}
